import React from 'react';
import { Link } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';

import { Loader } from '@components';
import { usersQuery } from '@queries';

const User = ({ user }) => {
  return (
    <div className="sb-sidebar-search-item">
      <div>
        <Link to={`/dashboard/users/${user.id}`} title={user.display_url}>
          {user.first_name} {user.last_name} {user.email}
        </Link>
      </div>
    </div>
  );
};

export const SearchUsers = ({ searchTerm }) => {
  // Fetch users
  const {
    data: usersData,
    isPending: usersIsPending,
    isError,
  } = useQuery(
    usersQuery({
      is_active: 1,
      q: searchTerm,
      limit: 3,
    }),
  );

  return (
    <>
      {usersIsPending && (
        <Loader className="sb-loader sb-loader-sidebar-search" />
      )}
      {!usersIsPending && usersData.objects.length > 0 && (
        <>
          <h2>Users</h2>
          <div className="sb-sidebar-search-row">
            {usersData.objects.map((user) => {
              return <User key={user.id} user={user} />;
            })}
          </div>
        </>
      )}
    </>
  );
};
